// ./src/pages/privates/Contract/New/StepFinished/styles.ts
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white.main};
  border-radius: 8px;
  padding: 6vh 4vw;
  margin-top: 1.5vh;
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4vh 0 2vh;
`;
